<template>
<v-app>
  <v-main>
    <v-container class="fill-height elevation-12" fluid>

       <m-globals/>

      <v-row align="center" justify="center">
        <v-col cols="12" sm="10" md="6">
          <v-card class="mx-auto mt-5">
            <v-toolbar color="primary" dark flat>
            <v-toolbar-title>{{title}}</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              
              <v-form>

                <div
                  style="margin-left: 30px"
                  v-if="is_create"
                >
                  <p
                    style="margin-top: 15px"
                  >
                    <b style="font-size: 1.5rem">Welcome to RedChirp!</b>
                  </p>

                  <p>Enter your work email address below.</p>
                    
                  <p>If your RedChirp account is ready to set up, we'll email you a link. Click the link to create your password and finish setting up your account.</p>

                </div>

                <v-text-field 
                  v-model="username" 
                  prepend-icon="mdi-account-circle" 
                  label="Email Address"
                  ref="username" 
                  autofocus
                  @keydown.enter="$event.preventDefault(); doSendReset();"
                />
                
                <div 
                  v-if="!is_create"
                  style="padding-left: 30px"
                >
                    You will be sent an email containing a link which will allow you to reset your password.
                </div>

                <p
                  style="padding-left: 30px; margin-top: 15px"
                >
                  <a 
                    v-on:click="$rc.contactSupport(is_create ? 'Sign in for the first time (start)' : 'Reset your password (start)')"
                  >
                    Need help?  Click here to contact RedChirp support.
                  </a>
                </p>

                <v-alert 
                  v-model="alert_visible" 
                  :type="alert_type" 
                  :color="alert_color"
                  dismissible
                  style="margin-top: 30px"
                >
                  {{ alert_text }}
                </v-alert>
               
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn v-show="!alert_visible" color="gray" v-on:click="doCancel">Cancel</v-btn>
              <v-btn 
                v-show="!alert_visible" 
                color="primary" 
                v-on:click="doSendReset"
                :disabled="!is_valid"
              >
                Send Email
              </v-btn>

            </v-card-actions>
          </v-card>

        </v-col>
      </v-row>
    </v-container>

  </v-main>
</v-app>
</template>

<script>

const Preconditions = require("@/js/Preconditions.js");


  export default {
    data() {
      return {
        username: '',
        alert_visible: false,
        alert_text: null,

        alert_type: 'error',
        alert_color: 'primary',
      }
    },
    methods: {
      doSendReset()
      {
        this.$rc.rest({
          'spinner': true,
          'endpoint': 'POST: /api/v1/auth/start-password-reset',
          'timeout': 21000,
        
          'params' : {
              'username': this.username,
              'send_email': true,
              'type': this.is_create ? 'create' : 'reset',
            },
        
          'on_success': (data) => {
              if ( data.email_sent )
              {
                this.alert_type = 'success';
                this.alert_color = null;
                this.alert_text = "Check your email for instructions.  If you do not receive the email, be sure to check your spam folders etc.";
                this.alert_visible = true;
              }
              else
              {
                this.alert_type = 'error';
                this.alert_text = "No user exists for the email entered.";
                this.alert_color = 'primary';
                this.alert_visible = true;
              }
            },
        
          'on_error': 'Unable to reset password',
        });
      },

        doCancel()
        {
            this.$router.push({name: 'sign-in', query: {'username' : this.username}});
        }
    },

    mounted () 
    {
        if ( Preconditions.isNull(this.$route.query.username) )
        {
            this.username = '';
        }
        else
        {
            this.username = this.$route.query.username;
        }

        this.$refs.username.focus();
    },
    
    computed: {
      title()
      {
          if ( this.is_create )
          {
            return 'Sign in for the first time';
          }

          return 'Reset Your Password'
      },

      is_create()
      {
        return this.$route.query.action == 'create';
      },

      is_valid()
      {
        if ( this.username == null ) return false;
        if ( this.username.length < 5 ) return false;
        if ( !this.username.includes('@') ) return false;
        if ( !this.username.includes('.') ) return false;

        return true;
      },
    },
  }
</script>

<style lang="scss" scoped>
</style>